import Carousel from './components/carousels';
import Header from "./components/header";

Carousel.SupportersCarousel();
Header.Superfish();
Header.MobileMenuToggle();

// NPM
import '@fancyapps/fancybox';
